import React from 'react';
import { FormattedMessage } from 'react-intl';
import ContentArea from '../ContentArea';
import Content from '../ContentArea/Content';
import Icon from '../Icon';
import { ERROR_404 } from '../../constants/strings';

const NotFound = () => (
  <div className="g-content">
    <ContentArea>
      <Content empty>
        <Icon name="404" size={194} className="mb4" />
        <p className="mh2 tc ttc f3 lh-copy">
          <FormattedMessage {...ERROR_404} />
        </p>
      </Content>
    </ContentArea>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound/index.jsx